import dbConnection from "../dbConnection";

const stepApi = {
    getAccounts: function () {
        return dbConnection.get("api/admin/step_datamodel/step_accounts");
    },
    submitAccount: function (payload) {
        return dbConnection.post("api/admin/step_datamodel/account", payload);
    },
    deleteAccount: function (id) {
        return dbConnection.delete(`api/admin/step_datamodel/account/${id}`);
    },
};

export default stepApi;
